var exports = {
  "kL": "ReportFlowThankYou.module__container___NkY4Sz",
  "rf": "ReportFlowThankYou.module__body___NkY4Sz",
  "uW": "ReportFlowThankYou.module__section___NkY4Sz",
  "R_": "ReportFlowThankYou.module__heading___NkY4Sz",
  "aP": "ReportFlowThankYou.module__box___NkY4Sz",
  "nM": "ReportFlowThankYou.module__row___NkY4Sz",
  "qg": "ReportFlowThankYou.module__rowText___NkY4Sz",
  "G9": "ReportFlowThankYou.module__rowTitle___NkY4Sz",
  "Z$": "ReportFlowThankYou.module__rowDescription___NkY4Sz",
};

module.exports = exports;
